export default __webpack_public_path__ + "static/media/mastercard.7af73083.svg";